import React from "react";
import Select from 'react-select';
import {
  Col,
  FormGroup,
  Label
} from 'reactstrap';
import { ErrorMessage } from 'formik'
 
const SubDocument = (props) => (
  <Col xs="12" md="4">
    <FormGroup>
      <Label>Sub Type Documents</Label>
      <Select name="subDocumentType"
        options={props.subDocuments}
        value={props.subDocumentType}
        onChange={(selectedOption) => props.setFieldValue('subDocumentType', selectedOption)}
      />
      <ErrorMessage name="subDocumentType">{msg => <div id="feedback" className="text-danger">{msg.value}</div>}</ErrorMessage>      
    </FormGroup>
  </Col>
)

export default SubDocument;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/SubDocument.js